import styled, { css } from 'styled-components';

import {
    Col,
    Row,
} from '@zillow/zrs-comet';

import {
    Card,
    IconChevronRightCircle,
    mediaMixin,
    spaceMixin,
    token,
} from '@zillow/constellation';

export const StyledColHiddenOnXs = styled(Col)`
    display: none;

    ${mediaMixin('lg', css`
        display: block;
    `)}
`;

export const StyledCard = styled(Card)`
    display: flex;
    flex-direction: row;
    align-items: center;

    height: 94px;
    padding: 16px;
    margin-bottom: ${spaceMixin('sm')};
    cursor: pointer;

    ${mediaMixin('lg', css`
        margin-left: 0;
        margin-right: 0;
    `)}
`;

export const StyledLabel = styled.div`
    flex-grow: 1;
`;

export const StyledRow = styled(Row)`
    ${mediaMixin('lg', css`
        display: block;
    `)}
`;

export const StyledIconChevronRightCircle = styled(IconChevronRightCircle)`
    color: ${token('colors.brand')};
    float: right;
    position: relative;
`;
